import { render, staticRenderFns } from "./test_index.vue?vue&type=template&id=a04b82ce&"
import script from "./test_index.vue?vue&type=script&lang=js&"
export * from "./test_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports